import type { CategorizationRule, KeywordMapping } from '../types';

export const RULES: CategorizationRule[] = [
  {
    category: "Investment",
    keywords: ["vanguard", "fidelity", "schwab", "529", "sofi securities", "m1 payments"],
  },
  {
    category: "Membership Fees",
    keywords: ["annual membership fee", "annual fee", "membership fee"],
  },
  {
    category: "Gifts & Donations",
    keywords: [
      "charity",
      "donation",
      "goodwill",
      "salvation army",
      "red cross",
      "church",
      "tithing",
      "patreon",
      "gofundme",
      "kickstarter",
    ],
  },
];

export const DISPLAY_NAMES: KeywordMapping[] = [
  { keyword: "vanguard", displayName: "Vanguard" },
  { keyword: "fidelity", displayName: "Fidelity" },
  { keyword: "schwab", displayName: "Charles Schwab" },
];
